<template>
  <div class="margin:auto">
    <HomeBanner></HomeBanner>

    <div class="simple-div" id="brand">
      <div class="div_top_title">
        <p>公司介绍</p>
        <p class="p_title_sub">ABOUT US</p>
      </div>

      <p class="txt">
        宁波宏邦保安服务有限公司是经浙江省公安厅批准，宁波市公安局监管，并于工商行政管理机构合法注册，从事现代安防业的综合服务供应商；是宁波市一家新型的专业化、规范化、科学化、现代化的服务型企业。
      </p>
      <div class="back-div" @click="navto('/Honor')">
        <p>了解更多</p>
      </div>

      <div class="num-row" id="num"
      data-aos="fade-up"
      data-aos-anchor-placement="top-center"
      data-aos-duration="2000"
      >
        <div class="simple_item_div">
          <div>
            <span class="simple_num">
              <!-- <count-to ref="mynum" :start-val='0' :end-val='List[0].yearNum' :duration='3000'></count-to> -->
              <countTo
                ref="mynum"
                :startVal="0"
                :endVal="2500"
                :duration="3000"
                :separator="null"
              ></countTo>
              <span class="simple_end">+</span></span
            >
          </div>
          <p class="simple_tv">安保人员</p>
        </div>
        <div class="line"></div>
        <div class="simple_item_div">
          <div>
            <span class="simple_num">
              <!-- <count-to ref="mynum1" :start-val='0' :end-val='List[0].brandNum' :duration='3000'></count-to> -->
              <countTo
                ref="mynum1"
                :startVal="0"
                :endVal="50"
                :duration="3000"
              ></countTo> </span
            ><span class="simple_end2">%</span>
          </div>
          <p class="simple_tv">管理人员为部队退役军人</p>
        </div>
        <div class="line"></div>
        <div class="simple_item_div">
          <div>
            <span class="simple_num">
              <!-- <count-to ref="mynum2" :start-val='0' :end-val='List[0].productsNum' :duration='3000'></count-to> -->
              <countTo
                ref="mynum2"
                :startVal="0"
                :endVal="200"
                :duration="3000"
              ></countTo>
              <span class="simple_end">+</span></span
            >
          </div>
          <p class="simple_tv">合作单位</p>
        </div>
      </div>
    </div>
    <div
      :class="
        businessItemPosition == 1
          ? 'business-div-1'
          : businessItemPosition == 2
          ? 'business-div-2'
          : businessItemPosition == 3
          ? 'business-div-3'
          : businessItemPosition == 4
          ? 'business-div-4'
          : 'business-div-5'
      "
       id="business"
    >
      <div class="div_top_title2">
        <p>主营业务</p>
        <p class="p_title_sub">MAIN BUSINESS</p>
      </div>
      <div class="business-row">
        <div
          :class="
            businessItemPosition == 1 ? 'business-item-hover' : 'business-item'
          "
          @mouseenter="changeBusinessItem(1)"
        >
          <img
            src="../../static/img/ic_business_1.png"
            v-show="businessItemPosition != 1"
          />
          <img
            src="../../static/img/ic_business_1_2.png"
            v-show="businessItemPosition == 1"
          />
          <p class="txt-1">安防护卫</p>
          <p class="txt-2">SERVICE ITEMS</p>
        </div>
        <div
          :class="
            businessItemPosition == 2 ? 'business-item-hover' : 'business-item'
          "
          @mouseenter="changeBusinessItem(2)"
        >
          <img
            src="../../static/img/ic_business_2.png"
            v-show="businessItemPosition != 2"
          />
          <img
            src="../../static/img/ic_business_2_2.png"
            v-show="businessItemPosition == 2"
          />
          <p class="txt-1">消防服务</p>
          <p class="txt-2">FIRE SERVICE</p>
        </div>
        <div
          :class="
            businessItemPosition == 3 ? 'business-item-hover' : 'business-item'
          "
          @mouseenter="changeBusinessItem(3)"
        >
          <img
            src="../../static/img/ic_business_3.png"
            v-show="businessItemPosition != 3"
          />
          <img
            src="../../static/img/ic_business_3_2.png"
            v-show="businessItemPosition == 3"
          />
          <p class="txt-1">保安培训</p>
          <p class="txt-2">RITY TRAINING</p>
        </div>
        <div
          :class="
            businessItemPosition == 4 ? 'business-item-hover' : 'business-item'
          "
          @mouseenter="changeBusinessItem(4)"
        >
          <img
            src="../../static/img/ic_business_4.png"
            v-show="businessItemPosition != 4"
          />
          <img
            src="../../static/img/ic_business_4_2.png"
            v-show="businessItemPosition == 4"
          />
          <p class="txt-1">物业服务</p>
          <p class="txt-2">COMMERCIAL SERVICE</p>
        </div>
        <div
          :class="
            businessItemPosition == 5 ? 'business-item-hover' : 'business-item'
          "
          @mouseenter="changeBusinessItem(5)"
        >
          <img
            src="../../static/img/ic_business_5.png"
            v-show="businessItemPosition != 5"
          />
          <img
            src="../../static/img/ic_business_5_2.png"
            v-show="businessItemPosition == 5"
          />
          <p class="txt-1">安检设备租售</p>
          <p class="txt-2">RENTAL AND SALES</p>
        </div>
      </div>
    </div>
    <div class="service-div" id="case">
      <div class="div_top_title" style="margin-left: 20rem">
        <p>服务案例</p>
        <p class="p_title_sub">SERVICE CASE</p>
      </div>

      <div class="middle_banner">
        <div class="swiper-button-prev swiper-button-prev1"></div>
        <div class="swiper-container mySwiper mySwiper1 menutype">
          <div class="swiper-wrapper">
            <!-- Slides -->
            <!-- <div class="swiper-slide" v-for="(item, index) in List" :key="index"> -->
            <div
              class="swiper-slide"
              v-for="(item, index) in CaseList"
              :key="index"
              v-if="index<5"
            >
              <div class="box_card menu-item" @click="navtoCaseDetail(item.id)" >
                <div class="card-img">
                  <img :src="item.showImg" />
                </div>
                <div class="bottom-div">
                  <div class="img-cover">
                    <!-- <img :src="item.cover" /> -->
                    <div class="txt">
                      <p>查看详情</p>
                    </div>
                  </div>
                  <div class="txt-div">
                    <p class="title">{{ item.title }}</p>
                    <p class="simple">{{ item.simple }}</p>
                  </div>
                </div>
              </div>
              <!-- <img src="../../static/img/3A证书.png" /> -->
            </div>
            <div
              class="swiper-slide"
            >
              <div class="box_card menu-item" @click="navto('/SafeCase')">
                <div class="card-img">
                  <!-- <img src="../../static/img/img_case_more.png" /> -->
                  <img :src="CaseList[5].showImg" />
                </div>
                <div class="bottom-div">
                  <div class="img-cover2">
                    <!-- <img :src="item.cover" /> -->
                    <!-- <div class="txt">
                      <p>查看详情</p>
                    </div> -->
                  </div>
                  <div class="txt-div2">
                    <p class="title">查看更多服务案例...</p>
                    <!-- <p class="simple">{{ item.simple }}</p> -->
                  </div>
                </div>
              </div>
              <!-- <img src="../../static/img/3A证书.png" /> -->
            </div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next1"></div>
      </div>
    </div>
    <div class="news-div" id="news">
      <div class="news-top-div">
        <div class="div_top_title">
        <p>宏邦资讯</p>
        <p class="p_title_sub">NEWS</p>
      </div>
        <div class="back-div" @click="navto('/News/News')">
          <p>更多</p>
        </div>
      </div>

      <div class="news-big-div">
        <div class="news-left-div"  @click="navtoNewsDetail(NewsList[0].id)">
          <img :src="NewsList[0].cover" />
          <el-row class="news-item">
            <el-col :md="6">
              <div>
                <p class="txt-day">
                  {{ getMonth(NewsList[0].activityTime) }}.{{
                    getDay(NewsList[0].activityTime)
                  }}
                </p>
                <p class="txt-year">{{ getYear(NewsList[0].activityTime) }}</p>
              </div>
            </el-col>
            <el-col :md="18">
              <div>
                <p class="txt-title">{{ NewsList[0].title }}</p>
                <p class="txt-simple">{{ NewsList[0].simple }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="news-right-div">
          <div
            v-for="(item, index) in NewsList"
            :key="index"
            @click="navtoNewsDetail(item.id)"
            style="cursor: pointer"
            class="news-item2"
            v-show="index != 0"
          >
            <el-row >
              <el-col :md="6">
                <div>
                  <p class="txt-day">
                    {{ getMonth(item.activityTime) }}.{{
                      getDay(item.activityTime)
                    }}
                  </p>
                  <p class="txt-year">{{ getYear(item.activityTime) }}</p>
                </div>
              </el-col>
              <el-col :md="18">
                <div>
                  <p class="txt-title">{{ item.title }}</p>
                  <p class="txt-simple">{{ item.simple }}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="partner-div" id="partner">
      <div class="div_top_title" style="margin-left:20rem">
        <p>合作伙伴</p>
        <p class="p_title_sub">PARTNER</p>
      </div>
      <FriendsBanner></FriendsBanner>
    </div>
  </div>
</template>

<script>
import FriendsBanner from "../components/FriendsBanner.vue";
import ShowLine from "../components/ShowLine.vue";
import ShowLineWhite from "../components/ShowLineWhite.vue";
import HomeBanner from "../components/HomeBanner.vue";
import PageBanner from "../components/PageBanner.vue";
import countTo from "vue-count-to";
export default {
  data() {
    return {
      path: "brand",
      NewsList: [
        {cover:''},
        {activityTime:''},
        {title:''},
        {simple:''},
      ],
      CaseList: [],
      businessItemPosition: 1,

      List: [
        {
          showImg: "",
        },
      ],
    };
  },
  components: {
    FriendsBanner,
    ShowLine,
    ShowLineWhite,
    HomeBanner,
    PageBanner,
    countTo,
  },
  mounted() {
    this.Init();
    var param = this.$route.query.param;
    this.path = param;
    console.log("param:" + param);
    this.navtoPartPath(this.path);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    clearInterval(this.timer);
    this.timer = null;
  },
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      console.log(to.path);
      var param = this.$route.query.param;
      this.path = param;
      console.log("param:" + param);
      this.navtoPartPath(this.path);
    },
    //监听轮播数据变化后再创建实例
    CaseList() {
      this.$nextTick(() => {
        var swiper = new Swiper(".mySwiper1", {
          slidesPerView: 4,
          spaceBetween: 30,
          centeredSlides: true,
          navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
          },
        });
        setTimeout(() => {
          swiper.slideTo(1, 100, false); 
        }, 1000);
      });
    },
  },
  methods: {
    Init() {
      this.getNewsList();
      this.getCaseList();
    },
    navtoPartPath(path) {
      if (path) {
        setTimeout(() => {
          document.getElementById(path).scrollIntoView();
        }, 500);
      }
    },

    getNewsList() {
      this.$axios
        .get("api/activity/list", {
          params: {
            page: 1,
            limit: 4,
            type: this.type,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.NewsList = response.data.page.list;
            }
          }.bind(this)
        );
    },
    getCaseList(menutype) {
      let plate = "";
      let business = "";
      let title = "";
      if (sessionStorage.getItem("input") !== "null") {
        title = sessionStorage.getItem("input");
      } else {
        if (this.isActive == 1) {
          plate = menutype;
        } else {
          business = menutype;
        }
      }

      this.$axios
        .get("api/safecase/list", {
          params: {
            page: 1,
            limit: 6,
            plate: plate,
            business: business,
            title: title,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.CaseList = response.data.page.list;
              for (let i = 0; i < this.List.length; i++) {
                this.CaseList[i].plates = this.CaseList[i].plates.replaceAll(
                  ",",
                  " / "
                );
                this.CaseList[i].business = this.CaseList[
                  i
                ].business.replaceAll(",", " / ");
              }
              sessionStorage.setItem("input", "null");
            }
          }.bind(this)
        );
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    navtoCaseDetail(id) {
      // this.$router.push('/News/NewsDetail/id='+id);
      let routeData = this.$router.resolve({
        path: "/SafeCase/id=" + id,
      });
      window.open(routeData.href, "_blank");
    },
    navto(path) {
      $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    navtoNewsDetail(id) {
      // this.$router.push('/News/NewsDetail/id='+id);
      let routeData = this.$router.resolve({
        path: "/News/NewsDetail/id=" + id,
      });
      window.open(routeData.href, "_blank");
      // this.$router.push(routeData.href);
    },
    startAnimate() {
      console.log(this.$refs.mynum1);
      this.$refs.mynum1.start();
      this.$refs.mynum.start();
    },
    playMultipleBanner() {
      new Swiper(".home_banner", {
        loop: true, // 循环模式选项
        autoplay: true,
        slidesPerView: 1,
        // centeredSlides: true,
        // Optional parameters
        // observer: true,
        // observeParents: true,
        // observeSlideChildren: true,
        // Navigation arrows
        pagination: {
          el: ".swiper-pagination",
        },
      });
    },
    getDay(date) {
      if(date){
        console.log(date.split("-")[2]);
      return date.split("-")[2];
      }
    },
    getMonth(date) {
      if(date){
        console.log(date.split("-")[1]);
        return date.split("-")[1];
      }
    },
    getMonthStr(date) {
      if(date){

        var date = new Date(date);
      console.log(date.toDateString());
      console.log(date.toDateString().split(" ")[1]);
      return date.toDateString().split(" ")[1];
      }
    },
    getYear(date) {
      if(date){
        console.log(date.split("-")[0]);
      return date.split("-")[0];
      }
    },
    changeBusinessItem(position) {
      console.log("changeBusinessItem:" + position);
      this.businessItemPosition = position;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.simple-div {
  background-image: url('../../static/img/首页底图1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 16rem 25rem;

  .simple_item_div {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .simple_border {
    border-left: 1px solid var(--textGary80);
    border-right: 1px solid var(--textGary80);
  }

  .txt {
    width: 50%;
    font-size: 1.6rem;
    color: var(--COLORE3B);
    margin-bottom: 5rem;
    margin-top: 3rem;
    line-height:1.77;
  }

  .num-row {
    width: 50%;
    margin-top: 15rem;
    display: flex;
    justify-content: space-between;

    .line {
      height: auto;
      width: 1px;
      background: var(--COLORE67);
    }
  }

  .simple_num {
    color: var(--COLORE3B);
    font-size: 5rem;
    font-family: DIN-Bold;
  }

  .simple_end {
    color: var(--COLORE3B);
    font-size: 3rem;
    font-family: DIN-Bold;
    vertical-align: super;
  }

  .simple_end2 {
    color: var(--COLORE3B);
    font-size: 5rem;
    font-family: DIN-Bold;
  }

  .simple_tv {
    color: var(--COLORE3B);
    font-size: 1.6rem;
    font-family: regular;
  }
}

.business-div-1 {
  background-image: url('../../static/img/首页底图2.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 50rem 20rem 10rem 20rem;
}

.business-div-2 {
  background-image: url('../../static/img/首页底图3.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 50rem 20rem 10rem 20rem;
}

.business-div-3 {
  background-image: url('../../static/img/首页底图4.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 50rem 20rem 10rem 20rem;
}

.business-div-4 {
  background-image: url('../../static/img/首页底图5.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 50rem 20rem 10rem 20rem;
}

.business-div-5 {
  background-image: url('../../static/img/首页底图6.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 50rem 20rem 10rem 20rem;
}

.business-row {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

.business-item {
  width: 28rem;
  display: flex;
  flex-direction: column;
  background: var(--COLOR00000040);
  border-radius: 6px;
  padding: 3rem 2rem;

  img {
    align-self: flex-end;
    width: 5rem;
    height: 5rem;
  }

  .txt-1 {
    color: white;
    font-size: 2.4rem;
    margin-bottom: 0;
  }

  .txt-2 {
    color: var(--textWhiteColor20);
    font-size: 2.2rem;
  }
}

.business-item-hover {
  background: var(--COLORE14B3E3);
  width: 28rem;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  padding: 3rem 2rem;

  img {
    align-self: flex-end;
    width: 5rem;
    height: 5rem;
  }

  .txt-1 {
    color: white;
    font-size: 2.4rem;
    margin-bottom: 0;
  }

  .txt-2 {
    color: var(--textWhiteColor20);
    font-size: 2.2rem;
  }
}

.business-item:hover {
  background: var(--COLORE14B3E3);
}

.service-div {
  background-image: url('../../static/img/首页底图7.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 10rem 0;
}

.news-div {
  background-image: url('../../static/img/首页底图8.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 10rem 20rem 10rem 20rem;
}
.news-top-div{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.partner-div {
  padding: 10rem 0;
}

.div_top_title {
  display: flex;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  color: var(--COLORE17);
  font-size: 4rem;
  font-family: medium;
  width: 50%;

  p {
    margin-top: 1rem;
    margin-bottom: 0;
    user-select: none;
  }

  .p_title_sub {
    position: absolute;
    font-size: 8rem;
    font-family: DIN-Bold;
    margin: 0 1rem;
    color: var(--COLORE1702);
    margin-left: 4%;
  }

  .litter_line_top {
    margin: auto;
    background-color: var(--COLORE17);
    height: 1px;
    width: 20%;
  }
}

.div_top_title2 {
  display: flex;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  font-size: 4rem;
  font-family: medium;
  width: 50%;

  p {
    margin-top: 1rem;
    margin-bottom: 0;
    user-select: none;
  }

  .p_title_sub {
    position: absolute;
    font-size: 8rem;
    font-family: DIN-Bold;
    margin: 0 1rem;
    color: var(--textWhiteColor20);
    margin-left: 4%;
  }

  .litter_line_top {
    margin: auto;
    background-color: var(--COLORE17);
    height: 1px;
    width: 20%;
  }
}

.back-div {
  cursor: pointer;
  margin-top: 0;
  width: 15rem;
  border-radius: 5rem;
  color: white;
  background: var(--COLORE14B3E3);
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

  p {
    margin: 0;
    font-size: 1.8rem;
  }
}

.swiper-button-prev {
  background-image: url('../../static/img/bannerleft.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  width: 5rem;
  height: 5rem;
  margin-left: 10rem;
  outline: none;
}

.swiper-button-prev:hover {
  background-image: url('../../static/img/bannerlefthover.png');
}

.swiper-button-next {
  background-image: url('../../static/img/bannerright.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  width: 5rem;
  height: 5rem;
  margin-right: 10rem;
  outline: none;
}

.swiper-button-next:hover {
  background-image: url('../../static/img/bannerrighthover.png');
}

.mySwiper {
  width: 100%;
  margin: 3rem 0;
}

.middle_banner {
  // display: flex;
  // justify-content: center;
  // justify-items: center;
  // align-content: center;
  // align-items: center;
  position: relative;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.box_card {
  height: 55rem;
  // margin: 2rem;
  // position: relative;
}

.menutype {
  font-size: 16px;
  justify-content: center;

  .menu-item {
    overflow: hidden;
    transition: all 0.4s ease 0s;
    text-align: center;
    border-radius: 3px;

    -webkit-box-shadow: 0px 3px 5px 1px rgba(54, 54, 54, 0.1);
    box-shadow: 0px 3px 5px 1px rgba(54, 54, 54, 0.1);
    .icon {
      margin-bottom: 10px;
    }

    .img-cover {
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 37rem;
      background: var(--COLORE14B3E370);
      display: flex;
      overflow: hidden;
      transition: all 0.4s ease 0s;

      img {
        margin: auto;
        width: 50%;
        height: auto;
        object-fit: contain;
      }

      .txt {
        margin: auto;
        cursor: pointer;
        width: 15rem;
        border-radius: 5rem;
        border: 1px solid white;
        color: white;
        padding: 0.5rem 0;
        display: flex;
        justify-content: center;

        p {
          margin: 0;
          font-size: 1.8rem;
        }
      }
    }
    .img-cover2 {
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 37rem;
      //background: var(--COLORE14B3E370);
      background-image: url('../../static/img/img_home_case_hover.png');
      display: flex;
      overflow: hidden;
      //transition: all 0.4s ease 0s;
      transform: translateY(-100%);

      img {
        margin: auto;
        width: 50%;
        height: auto;
        object-fit: contain;
      }

      .txt {
        margin: auto;
        cursor: pointer;
        width: 15rem;
        border-radius: 5rem;
        border: 1px solid white;
        color: white;
        padding: 0.5rem 0;
        display: flex;
        justify-content: center;

        p {
          margin: 0;
          font-size: 1.8rem;
        }
      }
    }
  }

  .menu-item:hover {
    // -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    cursor: pointer;

    .img-cover {
      transform: translateY(-100%);
      transition: all 0.4s ease 0s;
      -webkit-transform: translateY(-100%);
    }
    .img-cover2 {
      transform: translateY(-100%);
      transition: all 0.4s ease 0s;
      -webkit-transform: translateY(-100%);
    }
  }
}

.card-img {
  p {
    color: #0a396e;
    font-size: 2.4rem;
    margin: 10px 0;
  }

  img {
    width: 100%;
    height: 37rem;
    object-fit: cover;
  }
}

.bottom-div {
  position: relative;
}

.txt-div {
  width: 100%;
  position: absolute;
  background: white;
  //padding: 3rem;
  height: 18rem;
  z-index: 2;

  .title {
    margin: 3rem 3rem 1rem 3rem;
    font-size: 2rem;
    font-family: bold;
    color: var(--COLORE3A);
    text-align: start;
  }

  .simple {
    margin:0 3rem;
    font-size: 1.6rem;
    font-family: regular;
    color: var(--COLORE67);
    text-align: start;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}

.txt-div2 {
  display: flex;
  width: 100%;
  position: absolute;
  background: white;
  //padding: 3rem;
  height: 18rem;
  z-index: 2;
  justify-content: center;
  align-items: center;

  .title {
    //margin: 3rem 3rem 1rem 3rem;
    font-size: 2rem;
    font-family: bold;
    color: var(--COLORE3A);
    text-align: center;
  }
}

.news-big-div {
  margin-top:3rem;
  display: flex;
  justify-content: space-between;
}

.news-left-div {
  cursor pointer;
  width: 69rem;

  img {
    height: 43rem;
    object-fit: cover;
    width: 100%;
  }
}

.news-right-div {
  width: 69rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news-item {
  display: flex;
  // align-items: center;
  padding: 3rem 4rem;
  height: 24rem;
  background: white;
  box-shadow: 0px 3px 5px 1px rgba(54, 54, 54, 0.1);
}

.news-item2 {
  display: flex;
  // align-items: center;
  padding: 3rem 4rem;
  height: 20rem;
  background: white;
  box-shadow: 0px 3px 5px 1px rgba(54, 54, 54, 0.1);
}

.txt-day {
  color: var(--COLORE47);
  font-family: DIN-Bold;
  font-size: 4rem;
  line-height: 1;
  text-align: start;
}

.txt-year {
  line-height: 1;
  color: var(--COLORE67);
  font-family: DIN-Medium;
  font-size: 1.6rem;
  text-align: start;
}

.txt-title {
  color: var(--COLORE3B);
  font-family: bold;
  font-size: 2rem;
  text-align: start;
  overflow: hidden; 
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; 
}

.txt-simple {
  color: var(--COLORE67);
  font-family: regular;
  font-size: 1.8rem;
  text-align: start;
  overflow: hidden; 
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; 
}
@media screen and (max-width: 1200px) {
  .simple-div{
    background-position: right;
    padding:1rem;
    .num-row{
      width: 90%;
    }
  }
  .business-div-1{
    padding:10rem 1rem;
  }
  .business-div-2{
    padding:10rem 1rem;
  }
  .business-div-3{
    padding:10rem 1rem;
  }
  .business-div-4{
    padding:10rem 1rem;
  }
  .business-div-5{
    padding:10rem 1rem;
  }
  .business-row{
    img{
      align-self: center;
    }

    .txt-1{
      display:none;
    }
    .txt-2{
      display:none;
    }
  }
  .div_top_title{
    margin-left:0 !important;
  }
  .news-div{
    padding: 10rem 1rem;
  }
  .news-big-div{
    flex-direction: column;
  }
  .partner-div{
    padding: 10rem 1rem;
  }
  .swiper-slide {
    width:50% !important;
  }
  .news-item2{
    height:auto;
  }
  .news-item{
    height:auto;
  }
}
</style>
